<template>
  <div class="rl-bg">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "RlBg"
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 1100px){
  .rl-bg{
    width: 74.5vw;
    margin: 0 auto;
  }
}
@media screen and (max-width: 1100px){
  .rl-bg{
    width: 90vw;
    margin: 0 auto;
  }
}
</style>